/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S1_BodyInputs */

const tr_hakkimizda_s1_body = /** @type {(inputs: Hakkimizda_S1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel™, Türkiye'nin çoklu pazaryeri satıcıları için tasarlanmış, yapay zeka destekli bir yönetim platformudur. Trendyol, Shopify, Hepsiburada, n11 gibi pazaryerlerini; e-Fatura akışını, müşteri mesajlaşmasını, kargo operasyonlarını ve AI otomasyonunu tek altyapı üzerinde bütünleştirir.`)
};

const en_hakkimizda_s1_body = /** @type {(inputs: Hakkimizda_S1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel™ is an AI-powered management platform designed for Türkiye's multi-marketplace sellers. It brings marketplaces such as Trendyol, Shopify, Hepsiburada and n11, the e-Fatura flow, customer messaging, shipping operations and AI automation together on a single infrastructure.`)
};

const de_hakkimizda_s1_body = /** @type {(inputs: Hakkimizda_S1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel™ ist eine KI-gestützte Verwaltungsplattform, die für die Händler mit mehreren Marktplätzen in der Türkei entwickelt wurde. Sie vereint Marktplätze wie Trendyol, Shopify, Hepsiburada und n11, den e-Fatura-Ablauf, die Kundenkommunikation, die Versandabwicklung und die KI-Automatisierung auf einer einzigen Infrastruktur.`)
};

const ru_hakkimizda_s1_body = /** @type {(inputs: Hakkimizda_S1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel™ является платформой управления с поддержкой искусственного интеллекта, созданной для продавцов Турции, работающих на нескольких маркетплейсах. Она объединяет такие маркетплейсы, как Trendyol, Shopify, Hepsiburada, n11, процесс e-Fatura, переписку с клиентами, логистические операции и ИИ-автоматизацию в единой инфраструктуре.`)
};

/**
* | output |
* | --- |
* | "ShopPanel™ is an AI-powered management platform designed for Türkiye's multi-marketplace sellers. It brings marketplaces such as Trendyol, Shopify, Hepsibura..." |
*
* @param {Hakkimizda_S1_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s1_body = /** @type {((inputs?: Hakkimizda_S1_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S1_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s1_body(inputs)
	if (locale === "de") return de_hakkimizda_s1_body(inputs)
	if (locale === "ru") return ru_hakkimizda_s1_body(inputs)
	return tr_hakkimizda_s1_body(inputs)
});